import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCollapseVerticalStyle0 = cosmosIconCss;

const CosmosIconCollapseVertical$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCollapseVertical extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '93cbc29d357c1e70619e6ab805ad6f35bed2cdc8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ffd0827d6cdb9392ca4f361ea21518d04fcf6460', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3d6b1d0db34b75a12022a61d6dbc76c0b5d6691f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.871 4.387c.293-.346.055-.887-.39-.887H8.519c-.444 0-.682.541-.389.887l2.482 2.93a.507.507 0 0 0 .778 0l2.482-2.93ZM3.001 10.75a.5.5 0 0 1 .5-.5H18.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.5Zm5.517 7.75c-.444 0-.682-.541-.389-.887l2.482-2.93a.506.506 0 0 1 .778 0l2.482 2.93c.293.346.055.887-.39.887H8.519Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCollapseVerticalStyle0; }
}, [1, "cosmos-icon-collapse-vertical", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-collapse-vertical"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-collapse-vertical":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCollapseVertical$1);
            }
            break;
    } });
}

const CosmosIconCollapseVertical = CosmosIconCollapseVertical$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCollapseVertical, defineCustomElement };
